import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { AbilityByAreaChartPresentation } from "home/components/enem_proficiency_analysis"

class AbilityByAreaChartContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      chartPatch: null
    }
  }

  componentDidMount () {
    this.updateData()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters)) {
      this.updateData()
    }
  }

  updateData () {
    const { filters } = this.props
    const { knowledgeArea } = filters

    if (knowledgeArea === "") return

    requestResource("enem_proficiency_analysis/ability_by_area", filters, response =>
      this.setChartConfigFromResponse(response)
    )
  }

  setChartConfigFromResponse (response) {
    this.setState({
      chartPatch: response.data.patch
    })
  }

  render () {
    return <AbilityByAreaChartPresentation patch={this.state.chartPatch} />
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      userId: state.filters.userId,
      schoolYear: state.filters.schoolYear,
      schoolClass: state.filters.schoolClass,
      schoolId: state.filters.schoolId,
      knowledgeArea: state.filters["enemAnalysis/ability/knowledgeArea"]
    }
  }
}

export default connect(mapStateToProps)(AbilityByAreaChartContainer)
